import UnsupportedBrowserPage from '@/components/UnsupportedBrowserPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/unsupported')({
	component: () => <UnsupportedBrowserPage />,
})
